export default "__VITE_ASSET__Z9CKfT9i__"